import { giftingApplicationJson } from './trade-application-form-json/gifting'
import { hospitalityApplicationJson } from './trade-application-form-json/hospitality'
import { tradeAndWholesaleApplicationJson } from './trade-application-form-json/trade-and-wholesale'

export const TRADE_APPLICATION_SUBMISSION = 'TRADE_APPLICATION_SUBMISSION'

export enum TRADE_OPTIONS {
  Hospitality = 'hospitality',
  Gifting = 'gifting',
  TradeAndWholesale = 'wholesale',
  WhiteLabel = 'whitelabel',
}

export const TRADE_OPTIONS_VS_JSON = {
  [TRADE_OPTIONS.Hospitality]: hospitalityApplicationJson,
  [TRADE_OPTIONS.Gifting]: giftingApplicationJson,
  [TRADE_OPTIONS.TradeAndWholesale]: tradeAndWholesaleApplicationJson,
  [TRADE_OPTIONS.WhiteLabel]: giftingApplicationJson,
}
